import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatDate(date) {
  const d = new Date(date)
  const now = new Date()
  const diff = now - d
  
  if (diff < 60000) return 'Just now'
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`
  if (diff < 604800000) return `${Math.floor(diff / 86400000)}d ago`
  
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

export function truncate(str, length = 50) {
  if (!str) return ''
  return str.length > length ? str.slice(0, length) + '...' : str
}

export const contentTypeConfig = {
  note: { icon: 'StickyNote', color: '#FF6B6B', label: 'Note' },
  bookmark: { icon: 'Globe', color: '#4ECDC4', label: 'Web' },
  image: { icon: 'Image', color: '#E91E63', label: 'Image' },
  pdf: { icon: 'FileText', color: '#E53935', label: 'PDF' },
  docx: { icon: 'FileText', color: '#2196F3', label: 'Word' },
  doc: { icon: 'FileText', color: '#2196F3', label: 'Word' },
  xlsx: { icon: 'Table', color: '#4CAF50', label: 'Excel' },
  xls: { icon: 'Table', color: '#4CAF50', label: 'Excel' },
  pptx: { icon: 'Presentation', color: '#FF9800', label: 'PPT' },
  ppt: { icon: 'Presentation', color: '#FF9800', label: 'PPT' },
  txt: { icon: 'FileText', color: '#78909C', label: 'Text' },
  epub: { icon: 'BookOpen', color: '#9C27B0', label: 'EPUB' },
  transcript: { icon: 'Mic', color: '#7C4DFF', label: 'Voice' },
  unknown: { icon: 'File', color: '#607D8B', label: 'File' },
}
